<template>
  <div class="detail-dialog">
    <div class="detail-dialog-header">
      <div class="detail-dialog-header-title">
        {{ title }}
      </div>
      <div class="detail-dialog-header-button">
        <v-btn
          small
          outlined
          color="primary"
          @click.stop="$emit('save', editContext)"
        >
          <v-icon
            small
          >
            mdi-content-save-outline
          </v-icon>
          저장
        </v-btn>
        <!--        <div class="custom-spacer" />
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click.stop="$emit('save', editContext)"
                >
                  <v-icon
                    small
                  >
                    mdi-refresh
                  </v-icon>
                  초기화
                </v-btn>-->
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="primary"
          @click.stop="$emit('close')"
        >
          <v-icon
            small
          >
            mdi-close-box-outline
          </v-icon>
          닫기
        </v-btn>
      </div>
    </div>
    <div class="custom-spacer" />
    <div v-if="!!editContext" class="detail-dialog-body">
      <div class="sub-container">
        <div class="sub-title">
          요금제 선택
        </div>
        <div class="sub-content-wrap">
          <div class="sub-content-item">
            기본요금제:
            <select :value="editContext.planId" @change="e => onChangePlanId(e)">
              <option :value="null" disabled>
                선택 안함
              </option>
              <option
                v-for="bpItem in basePlanItems"
                :key="`base-plan-${bpItem.planId}`"
                :value="bpItem.planId"
                :disabled="bpItem.useYn !== 'Y'"
              >
                {{ bpItem.planName }}
              </option>
            </select>
            <span
              v-if="!editContext || !editContext.planId"
              class="ml-5"
              style="color: red"
            >
              요금제를 선택하세요.
            </span>
          </div>
        </div>
      </div>
      <div class="custom-spacer" />

      <template v-if="editContext.planId">
        <div class="sub-container">
          <div class="sub-title">
            기본정보
          </div>
          <div class="sub-content-wrap">
            <div class="sub-content-item one-half">
              <span>요금제 명:</span>
              <input
                v-model="editContext.planName"
                type="text"
              >
            </div>
            <div class="sub-content-item one-half">
              <span>기본요금 ({{ selectedBasePlan.baseFee }} 원):</span>
              <input
                v-model="editContext.baseFee"
                style="width: 100px"
                type="number"
                max="99999999"
              > 원
            </div>
          </div>
          <div class="sub-content-wrap">
            <div class="sub-content-item one-half">
              <span>약정 여부:</span>
              <select v-model="editContext.contractYn">
                <option value="Y">
                  (Y): 약정 금액 적용
                </option>
                <option value="N">
                  (N): 약정 금액 미적용
                </option>
              </select>
            </div>
            <div class="sub-content-item one-half">
              <span>모니터링 기본제공 합산여부:</span>
              <select v-model="editContext.monitoringBaseCntSumYn">
                <option value="Y">
                  (Y): 잉크젯/레이저 합산
                </option>
                <option value="N">
                  (N): 잉크젯/레이저 별도
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="custom-spacer" />
        <div class="sub-container">
          <div class="sub-title">
            부가서비스
          </div>
          <div class="sub-content-wrap">
            <table>
              <thead>
              <tr>
                <th>
                  부가서비스 명
                </th>
                <th>
                  서비스 요금
                </th>
                <th>
                  보류 기한
                </th>
                <th>
                  삭제
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, idx) in convertSupplyServiceSubPlan" :key="'supply-service-'+idx">
                <td>
                  <input
                    v-model="item.itemName"
                    style="width: 300px"
                    type="text"
                  >
                </td>
                <td>
                  <input
                    v-model="item.addFee"
                    style="width: 200px"
                    type="number"
                    min="0"
                    max="99999999"
                  > 원
                </td>
                <td>
                  <input
                    v-model="item.holdDatetime"
                    type="date"
                    max="2099-12-31"
                    min="2020-01-01"
                    pattern="\d{4}-\d{2}-\d{2}"
                  > 까지
                </td>
                <td>
                  <div class="d-flex justify-center">
                    <v-btn
                      small
                      icon
                      color="primary"
                      @click.stop="item.deleteYn = 'Y'"
                    >
                      <v-icon
                        small
                      >
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="d-flex justify-center">
                    <v-btn
                      small
                      color="primary"
                      @click.stop="addSupplyService()"
                    >
                      <v-icon
                        small
                      >
                        mdi-plus
                      </v-icon>
                      부가 서비스 추가
                    </v-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="custom-spacer" />
        <div class="sub-container">
          <div class="sub-title">
            추가료 정보
          </div>
          <div class="sub-content-wrap">
            <table>
              <thead>
              <tr>
                <th>
                  추가료 구분
                </th>
                <th colspan="2">
                  기본제공
                </th>
                <th colspan="2">
                  추가기준
                </th>
                <th colspan="2">
                  추가료
                </th>
                <th>
                  보류 기한
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in convertSubPlan" :key="'sublan-'+item.codeKey" style="font-size: 12px">
                <td>{{ item.codeValue }}</td>
                <td>
                  {{ findBasePlanSub(item.codeKey).standardCnt }} 개
                </td>
                <td>
                  <input
                    v-model="item.planItem.standardCnt"
                    style="width: 80px"
                    type="number"
                    max="99999999"
                    min="0"
                  > 개
                </td>
                <td>
                  {{ findBasePlanSub(item.codeKey).addCnt }} 개 당
                </td>
                <td>
                  <input
                    v-model="item.planItem.addCnt"
                    style="width: 80px"
                    type="number"
                    max="99999999"
                    min="0"
                  > 개 당
                </td>
                <td>
                  {{ findBasePlanSub(item.codeKey).addFee }} 원
                </td>
                <td>
                  <input
                    v-model="item.planItem.addFee"
                    style="width: 80px"
                    type="number"
                    min="0"
                    max="99999999"
                  > 원
                </td>
                <td>
                  <input
                    v-model="item.planItem.holdDatetime"
                    type="date"
                    max="2099-12-31"
                    min="2020-01-01"
                    pattern="\d{4}-\d{2}-\d{2}"
                  > 까지
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="custom-spacer" />
        <div class="sub-container">
          <div class="sub-title">
            비고
          </div>
          <div class="sub-content-wrap">
          <textarea
            v-model="editContext.remark"
          />
          </div>
        </div>
      </template>
    </div>
    <div class="custom-spacer" />
    <div class="detail-dialog-footer" />
  </div>
</template>

<script>
import time from "../../assets/plugins/mps-common/time";
import {cloneDeep} from "lodash";
import {PATH} from "@/constants";
import {DateTime} from "luxon";

export default {
  name: "RentalcompanyPlanDetail",
  props: {
    item: {
      type: Object,
      default: undefined
    },

    subItemCodes: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      default: '상세',
    },

    basePlanItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      context: {
        rentalcompanyPlanId: undefined,
        rentalcompanyId: undefined,
        planId: undefined,
        planName: undefined,
        baseFee: undefined,
        contractYn: undefined,
        monitoringBaseCntSumYn: undefined,
        remark: undefined,
        useYn: undefined,
        register: undefined,
        registerName: undefined,
        regDatetime: undefined,
        planItems: [],
      },
      editContext: {
        rentalcompanyPlanId: undefined,
        rentalcompanyId: undefined,
        planId: undefined,
        planName: undefined,
        baseFee: undefined,
        contractYn: undefined,
        monitoringBaseCntSumYn: undefined,
        remark: undefined,
        useYn: undefined,
        register: undefined,
        registerName: undefined,
        regDatetime: undefined,
        planItems: [],
      }
    }
  },
  computed: {
    convertSubPlan() {
      if (!this.editContext || this.subItemCodes.length <= 0)
        return []

      const result = this.subItemCodes.map(e => {
        let planItem = this.editContext.planItems.find(t => t.codeKey === e.codeKey)
        if (!planItem) {
          return {
            ...e,
            planItem: {
              itemType: 'A',
              standardCnt: 0,
              addCnt: 0,
              addFee: 0.0,
            }
          }
        } else {
          return {
            ...e,
            planItem
          }
        }
      })

      return result
    },

    convertSupplyServiceSubPlan() {
      return this.editContext.planItems.filter(e => e.itemType === 'B' && e.deleteYn != 'Y')
    },

    selectedBasePlan() {
      if (!this.basePlanItems || this.basePlanItems.length <= 0 || !this.editContext.planId) {
        return undefined
      }

      return this.basePlanItems.find(e => e.planId === this.editContext.planId)
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!!newVal && !!newVal.rentalcompanyId)
          this.loadRcPlan()
      }
    },

    context: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const cloneItem = cloneDeep(newVal)
        this.editContext.rentalcompanyPlanId = cloneItem.rentalcompanyPlanId || undefined
        this.editContext.rentalcompanyId = cloneItem.rentalcompanyId || undefined
        this.editContext.planId = cloneItem.planId || undefined
        this.editContext.planName = cloneItem.planName || undefined
        this.editContext.baseFee = cloneItem.baseFee || undefined
        this.editContext.contractYn = cloneItem.contractYn || undefined
        this.editContext.monitoringBaseCntSumYn = cloneItem.monitoringBaseCntSumYn || undefined
        this.editContext.remark = cloneItem.remark || undefined
        this.editContext.useYn = cloneItem.useYn || undefined
        this.editContext.register = cloneItem.register || undefined
        this.editContext.registerName = cloneItem.registerName || undefined
        this.editContext.regDatetime = cloneItem.regDatetime || undefined
        this.editContext.planItems.splice(0, this.editContext.planItems.length)
        this.editContext.planItems.push(...cloneItem.planItems)
      }
    },
  },

  methods: {
    async loadRcPlan() {
      try {
        const res = await this.$request(PATH.MPS_PLAN.RENTALCOMPANY_PLAN)
          .setObject({
            rentalcompanyId: this.item.rentalcompanyId,
            useYn: 'Y'
          })
          .catch(e => {})
          .enqueue()
        if (!res || res === '' || !res.data || res.data.length <= 0) {
          this.makePlanContext()
        } else {
          this.makePlanContext(res.data[0])
        }
      } catch (e) {
        console.error(e)
      }
    },

    onChangePlanId(event) {
      const planId = Number(event.target.value || -1)
      if (!planId)
        return
      const findItem = cloneDeep(this.basePlanItems.find(e => Number(e.planId) === planId))

      if (!findItem)
        return;

      this.editContext.rentalcompanyPlanId = undefined
      this.editContext.planId = findItem.planId
      this.editContext.planName = findItem.planName
      this.editContext.baseFee = findItem.baseFee
      this.editContext.contractYn = 'N'
      this.editContext.remark = findItem.remark
      this.editContext.planItems.splice(0, this.editContext.planItems.length)
      findItem.planItems.forEach(e => {
        this.editContext.planItems.push({
          ...e,
          itemType: 'A',
          holdDatetime: undefined,
        })
      })
    },

    makePlanContext(res = undefined) {
      this.context.planItems.splice(0, this.context.planItems.length)

      if (!res) {
        this.context.rentalcompanyId = this.item.rentalcompanyId
        this.context.planId = null
        this.context.planName = ''
        this.context.baseFee = ''
        this.context.contractYn = 'N'
        this.context.monitoringBaseCntSumYn = 'N'
        this.context.remark = ''
        this.context.useYn = 'Y'

        this.subItemCodes.forEach(e => {
          this.context.planItems.push(
            {
              planId: undefined,
              itemType: 'A',
              itemName: e.codeValue,
              codeKey: e.codeKey,
              standardCnt: 0,
              addCnt: 0,
              addFee: 0.00,
              remark: '',
              useYn: 'Y',
              deleteYn: 'N',
              holdDatetime: undefined,
            }
          )
        })
      } else {
        this.context.rentalcompanyId = res.rentalcompanyId
        this.context.planId = res.planId
        this.context.planName = res.planName
        this.context.baseFee = res.baseFee
        this.context.contractYn = res.contractYn
        this.context.monitoringBaseCntSumYn = res.monitoringBaseCntSumYn
        this.context.remark = res.remark
        this.context.useYn = res.useYn
        // this.context.planItems.push(...res.planItems)

        const planItems = res.planItems.map(e => {
          const {holdDatetime, ...others} = e
          return {
            ...others,
            holdDatetime: holdDatetime && holdDatetime !== '' ? DateTime.fromISO(holdDatetime).toFormat('yyyy-MM-dd') : undefined
          }
        })

        this.context.planItems.push(...planItems)

        this.subItemCodes.forEach(e => {
          const findItem = this.context.planItems.find(t => t.codeKey === e.codeKey)
          if (!findItem) {
            this.context.planItems.push(
              {
                planId: undefined,
                itemType: 'A',
                itemName: e.codeValue,
                codeKey: e.codeKey,
                standardCnt: 0,
                addCnt: 0,
                addFee: 0.00,
                remark: '',
                useYn: 'Y',
                deleteYn: 'N',
                holdDatetime: undefined,
              }
            )
          }
        })
      }
    },

    addSupplyService() {
      this.editContext.planItems.push(
        {
          planId: undefined,
          itemType: 'B',
          itemName: '부가서비스',
          codeKey: null,
          standardCnt: 0,
          addCnt: 1,
          addFee: 0.00,
          remark: '',
          useYn: 'Y',
          deleteYn: 'N',
          holdDatetime: undefined,
        }
      )
    },

    findBasePlanSub(codeKey) {
      let result = {
        standardCnt: 0,
        addCnt: 0,
        addFee: 0,
      }
      if (!this.selectedBasePlan.planItems || this.selectedBasePlan.planItems.length <= 0)
        return result
      const findItem = this.selectedBasePlan.planItems.find(e => e.codeKey === codeKey)

      return findItem || result
    },
  },
}
</script>

<style scoped>
.detail-dialog {
  background: #fff;
  padding: 12px;
  width: 100%;
  min-width: 1000px;
  max-width: 1000px;
}

.detail-dialog > div {
  padding: 4px 0;
}

.detail-dialog-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dddddd;
}

.detail-dialog-header-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.detail-dialog-header-button {
  display: flex;
}

.detail-dialog-body {

}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.sub-title {
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  color: #333333;
}

.sub-content-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 32px;
}

.sub-content-item {
  display: flex;
  padding-right: 32px;
  justify-content: space-between;
}

.sub-content-item.one-half {
  width: calc(100% / 2);
}

.sub-content-item input,
.sub-content-item select{
  max-width: 200px;
}

input,
select {
  flex: 1;
  margin-left: 16px;
  border-bottom: 1px solid #0c98fe;
  color: #1867c0;
  outline: none;
  padding-right: 24px;
  position: relative;
}

select {
  background: url(/img/icon_selectarrow.png) no-repeat right center;
}

textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #d0d0d0;
  resize: none;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;
}

table thead tr th {
  background: #0c98fe;
  padding: 2px;
  color: white;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr:nth-child(2n) {
  background: #f4f4f4;
}

table tbody tr td {
  padding: 8px 4px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr td input {
  width: 120px;
}

table tbody tr td:nth-child(1) {
  text-align: right;
}


/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>